/**
 * Waitlist API — types + thin function wrappers around the two backend endpoints.
 *
 *   GET  /api/v1/waitlist/placeholder?lang=mk
 *     → 200 { placeholder, variant: "A"|"B", language: "mk"|"en" }
 *
 *   POST /api/v1/waitlist
 *     body { email, note: string|null, variant: "A"|"B", language: "mk"|"en" }
 *     → 200 { id, email, created_at }
 *     idempotent on email — re-submitting returns the existing row.
 *
 * No Zod yet (not installed in `web/` — see lib/api/client.ts note). The
 * shapes are typed with TS interfaces and trusted at the network boundary.
 * When Zod lands, schema.parse(body) goes here, not in client.ts.
 */
import { api } from './client';

export type WaitlistVariant = 'A' | 'B';
export type WaitlistLanguage = 'mk' | 'en';

export type WaitlistPlaceholder = {
  placeholder: string;
  variant: WaitlistVariant;
  language: WaitlistLanguage;
};

export type WaitlistJoinInput = {
  email: string;
  note: string | null;
  variant: WaitlistVariant;
  language: WaitlistLanguage;
};

export type WaitlistEntry = {
  id: string;
  email: string;
  created_at: string;
};

export function fetchWaitlistPlaceholder(lang: WaitlistLanguage): Promise<WaitlistPlaceholder> {
  return api.get<WaitlistPlaceholder>(
    `/api/v1/waitlist/placeholder?lang=${encodeURIComponent(lang)}`,
  );
}

export function joinWaitlist(input: WaitlistJoinInput): Promise<WaitlistEntry> {
  return api.post<WaitlistEntry>('/api/v1/waitlist', input);
}
